<template>
  <div>
    <PageHead title="审计报告督导台账"></PageHead>
    <div class="oa-layout-content">
      <div class="search-flex">
        <div class="query-top-select">
          <div class="query-cont">
            <div class="query-view mr20">
              <div class="query-view-lable">被审计机构：</div>
              <a-tree-select
                allowClear
                v-model="queryForm.auditedOrgId"
                class="w200"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :tree-data="treeData"
                placeholder="请选择部门"
                tree-default-expand-all
                :replaceFields="{
                  key: 'id',
                  value: 'id',
                  children: 'treeList',
                  title: 'organizationName'
                }"
              >
              </a-tree-select>
            </div>
            <div class="query-view">
              <div class="query-view-lable">审计报告文号：</div>
              <a-input
                allowClear
                class="w200"
                placeholder="请输入"
                v-model="queryForm.auditReportNumber"
              />
            </div>
            <div class="query-view">
              <div class="query-view-lable">审计类型：</div>
              <a-select
                allowClear
                class="w200"
                placeholder="不限"
                v-model="queryForm.auditType"
              >
                <a-select-option
                  v-for="item in auditTypeList"
                  :value="item.valuename"
                  :key="item.id"
                >
                  {{ item.keyname }}</a-select-option
                >
              </a-select>
            </div>
          </div>
          <blank height="20"> </blank>
          <div class="query-cont">
            <div class="query-view">
              <div class="query-view-lable">表单状态：</div>
              <a-select
                allowClear
                placeholder="不限"
                class="w200"
                v-model="queryForm.state"
              >
                <a-select-option :value="0">待提交</a-select-option>
                <a-select-option :value="1">正在审批</a-select-option>
                <a-select-option :value="2">已归档</a-select-option>
                <a-select-option :value="3">退回</a-select-option>
                <!-- <a-select-option :value="4">取消</a-select-option> -->
              </a-select>
            </div>
          </div>
        </div>
        <div class="search-flex-itemm">
          <a-button type="primary" @click="subMit" :loading="loading">
            查询</a-button
          >
          <a-button :style="{ marginLeft: '8px' }" @click="cancel()">
            取消
          </a-button>
        </div>
      </div>
      <div class="mb20 search-btns mt20">
        <!-- <a-button type="primary" @click="addTask()" icon="plus">
          发起整改</a-button
        > -->
        <span class="statistics"> 检索统计： {{ total }} 条 </span>
      </div>

      <a-table
        :pagination="false"
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="(record) => record.id"
      >
        <span slot="index" slot-scope="text, record, index">
          {{ index + 1 + (page - 1) * 10 }}
        </span>
        <span slot="auditType" slot-scope="text">{{
          getByTypeName(text, auditTypeList)
        }}</span>
        <div slot="state" class="statusDiv" slot-scope="text">
          <div v-if="text == 0" class="dot0 mr5"></div>
          <div v-if="text == 1" class="dot1 mr5"></div>
          <div v-if="text == 2" class="dot2 mr5"></div>
          <div v-if="text == 3" class="dot3 mr5"></div>
          <div v-if="text == 4" class="dot4 mr5"></div>
          <span v-if="text == 0"> 待提交 </span>
          <span v-if="text == 1"> 正在审批 </span>
          <span v-if="text == 2"> 已归档 </span>
          <span v-if="text == 3"> 退回 </span>
          <span v-if="text == 4"> 取消 </span>
        </div>
        <div slot="action" slot-scope="text, record">
          <a-button
            type="link"
            class="btn-link"
            @click="goDetial(record.id, 1)"
          >
            查看
          </a-button>
          <template v-if="record.state == 0">
            <a-divider type="vertical" />
            <a-button type="link" class="btn-link" @click="goDetial(record.id)">
              修改
            </a-button>
            <a-divider type="vertical" />
            <a-button
              type="link"
              class="btn-link"
              @click="showDeleteConfirm(record.id)"
            >
              删除
            </a-button>
          </template>
          <!-- <a-divider type="vertical" v-if="record.recallButton" />
          <a-button
            v-if="record.recallButton"
            type="link"
            class="btn-link"
            @click="showRecallConfirm(record)"
          >
            撤回
          </a-button> -->
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination
          :current="page"
          :default-current="page"
          :total="total"
          :pageSize="size"
          @change="pageChange"
        />
      </div>
    </div>
    <appfloor></appfloor>
    <a-modal
      width="560px"
      v-model="rectifyVisible"
      title="发起任务配置"
      @ok="handleOk"
    >
      <a-alert
        message="流程提示：1、选择任务机构  2、选择任务时间范围  3、提交"
        type="info"
        show-icon
        style="margin-bottom: 20px"
      />
      <div class="modalItem">
        <div class="modelTitle">1. 选择任务机构</div>
        <a-tree-select
          multiple
          v-model="taskData.orgIds"
          class="w500"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          :tree-data="treeData"
          placeholder="请选择部门"
          tree-default-expand-all
          :replaceFields="{
            key: 'id',
            value: 'id',
            children: 'treeList',
            title: 'organizationName'
          }"
        >
        </a-tree-select>
      </div>
      <div class="modalItem">
        <div class="modelTitle">2. 选择任务时间范围</div>
        <a-range-picker
          class="w300"
          v-model="timeHorizon"
          :valueFormat="dateFormat"
        ></a-range-picker>
      </div>
      <div class="modalItem"><a-switch v-model="remindMethod" /> 系统提醒</div>
      <div class="modalItem">
        任务时间截止前
        <a-input-number v-model="taskData.remindDay" :min="0" :max="9999999" />
        天，发系统消息提醒。
      </div>
      <div class="modalItem">
        <a-checkbox-group v-model="operator">
          <a-checkbox value="1" name="type"> 任务发起人 </a-checkbox>
          <a-checkbox value="2" name="type"> 任务提交人 </a-checkbox>
        </a-checkbox-group>
      </div>
    </a-modal>
  </div>
</template>
<script>
const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    scopedSlots: { customRender: 'index' },
    width: 80
  },
  {
    title: '审计文号',
    dataIndex: 'auditReportNumber',
    key: 'auditReportNumber',
    ellipsis: true
  },

  {
    title: '被审计单位',
    dataIndex: 'auditedOrgName',
    key: 'auditedOrgName',
    ellipsis: true
  },
  {
    title: '审计报告时间',
    dataIndex: 'auditReportTime',
    key: 'auditReportTime',
    ellipsis: true
  },
  {
    title: '审计类型',
    dataIndex: 'auditType',
    key: 'auditType',
    scopedSlots: { customRender: 'auditType' },
    ellipsis: true
  },
  {
    title: '表单状态',
    dataIndex: 'state',
    key: 'state',
    scopedSlots: { customRender: 'state' },
    ellipsis: true
  },
  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作',
    align: 'left',
    width: 180
  }
]

import { mapState, mapActions } from 'vuex'
import { recallProcessFn } from '@/utils/utils'
import {
  getAuditReportRectification,
  delAuditReportRectification,
  addTask
} from './api/api'
export default {
  data() {
    return {
      queryForm: {},
      data: [],
      columns,
      total: 0,
      page: 1,
      size: 10,
      loading: false,
      rectifyVisible: false,
      remindMethod: true,
      operator: [],
      taskData: {},
      dateFormat: 'YYYY-MM-DD',
      timeHorizon: [] //时间范围
    }
  },
  computed: {
    ...mapState({
      auditTypeList: (state) => state.bytype.auditTypeList, // 	审计类型
      treeData: (state) => state.app.treeData // 组织机构树
    })
  },
  created() {
    this.getorganizeListFn()
    this.getauditType()

    this.load()
  },
  methods: {
    // 提交 未审批 可撤回流程
    showRecallConfirm(record) {
      const recallProcessPromise = new Promise((resolve, reject) => {
        recallProcessFn(
          this,
          record,
          resolve,
          reject,
          'audit-report-rectification'
        )
      })
      recallProcessPromise
        .then((value) => {
          this.load()
        })
        .catch((error) => {
          this.load()
        })
    },
    ...mapActions(['getorganizeListFn', 'getauditType']),
    //通过字典值过去字典名
    getByTypeName(value, list) {
      let byType = list.find((item) => {
        return item.valuename == value
      })
      if (byType) {
        return byType.keyname
      } else {
        return value
      }
    },
    // 拉取列表
    load() {
      this.loading = true
      let params = this.queryForm
      params.page = this.page
      params.size = this.size
      getAuditReportRectification(params).then((res) => {
        this.loading = false
        if (res.data.code == 0) {
          this.data = res.data.data
          this.total = res.data.count
        }
      })
    },
    showDeleteConfirm(id) {
      this.$confirm({
        title: '确定删除吗?',
        okType: 'danger',
        onOk: () => {
          delAuditReportRectification({ id }).then((res) => {
            if (res.data.code == 0) {
              this.$message.success('删除成功')
              this.page = 1
              this.load()
            }
          })
        }
      })
    },
    goDetial(id, type) {
      if (type) {
        this.$router.push('/standingBookDetails?id=' + id + '&isEdit=1')
      } else {
        if (id) {
          this.$router.push('/standingBookDetails?id=' + id)
        } else {
          this.$router.push('/standingBookDetails')
        }
      }
    },
    pageChange(pageber) {
      this.page = pageber
      this.load()
    },
    cancel() {
      //取消
      this.queryForm = {}
    },
    subMit() {
      this.page = 1
      this.load()
    },
    addTask() {
      this.rectifyVisible = true
    },
    handleOk() {
      if (this.timeHorizon.length > 0) {
        //选择了时间范围
        this.taskData.startTime = this.timeHorizon[0]
        this.taskData.endTime = this.timeHorizon[1]
      }
      if (this.operator.length > 0) {
        //提醒设置
        this.operator.forEach((item, index) => {
          if (item == 1) {
            this.taskData.give = 1
          }
          if (item == 2) {
            this.taskData.receive = 1
          }
        })
      } else {
        this.taskData.give = 2
        this.taskData.receive = 2
      }
      if (this.remindMethod) {
        this.taskData.remindMethod = 1
      } else {
        this.taskData.remindMethod = 2
      }

      addTask(this.taskData).then((res) => {
        if (res.data.code == 0) {
          this.$message.success('发起整改任务成功')
          this.taskData = {}
          this.timeHorizon = []
          this.operator = []
          this.rectifyVisible = false
        }
      })
    },
    handleChange() {},
    onChange() {}
  }
}
</script>
<style lang="scss" scoped>
.search-flex {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  .query-top-select {
    width: calc(100% - 200px);
    .query-cont {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .query-view {
        display: flex;
        align-items: center;
        justify-content: center;
        .query-view-lable {
          width: 100px;
          height: 22px;
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          line-height: 22px;
          text-align: right;
          margin-right: 10px;
        }
      }
    }
  }
  .search-flex-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}
.search-btns {
  position: relative;
  height: 20px;
  .statistics {
    position: absolute;
    right: 50px;
    font-size: 14px;
  }
}

.statusDiv {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.modalItem {
  margin-bottom: 20px;
}
.modelTitle {
  padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/standingBook/index.vue